import './Contact.css'
const Contact = () => {
    return (
        <div className= 'section'>
            <h1> For Additional Inquiries </h1>
            <div id = 'contact-info'>
                <form
                    name = 'contact-form'
                    method ='POST'
                    data-netlify = 'true'>
                    <input type="hidden" name="form-name" value = "contact-form" />
                    <div className="userInfo">
                        <h3>Name</h3>
                        <input type ='text' name = 'name' placeholder = 'Your name...' required/>
                    </div>
                    <div className="userInfo">
                        <h3>Email</h3>
                        <input type ='email' name = 'email' placeholder = 'Your email...' required/>
                    </div>
                    <div className="userInfo">
                        <h3>Phone Number</h3>
                        <input type="number" name ='phone' placeholder = 'Your phone number...'/>
                    </div>
                    <div className="userInfo">
                        <h3>Message</h3>
                        <textarea name="message" placeholder = 'Your message...' cols="30" rows="10" required/>
                    </div>
                    <div className="submit-container">
                        <button type = 'submit'> Send Message </button>
                    </div>
                </form>
            </div>
        </div>
    )
}
export default Contact;